import { IFormCategories } from 'legacy/lut/classes/models/IFormCategories'
import React from 'react'

import { Main } from './partnerPreviewMode/Main'
import { Sidebar } from './partnerPreviewMode/Sidebar'

import styles from './PartnerPreviewMode.module.scss'

interface IProps {
  currentCompany: any
  paymentTypes: IFormCategories[]
  logoItem: any
  noData: any
  images: any
  areasOfFocus: { name: string }[]
  industriesCovered: { name: string }[]
  software: { name: string }[]
  categories: any
  currentDay: any
  setCurrentDay: (arg0: any) => void
  handleCloseEdit: (isChanged: boolean, item: any) => void
}

export const PartnerPreviewMode = ({
  currentCompany,
  paymentTypes,
  logoItem,
  noData,
  images,
  areasOfFocus,
  industriesCovered,
  software,
  categories,
  setCurrentDay,
  handleCloseEdit,
  currentDay,
}: IProps) => {
  return (
    <div className={styles.root}>
      <Main
        className={styles.main}
        currentCompany={currentCompany}
        paymentTypes={paymentTypes}
        areasOfFocus={areasOfFocus}
        industriesCovered={industriesCovered}
        software={software}
        noData={noData}
        categories={categories}
      />

      <Sidebar
        className={styles.aside}
        currentCompany={currentCompany}
        logoItem={logoItem}
        noData={noData}
        images={images}
        currentDay={currentDay}
        setCurrentDay={setCurrentDay}
        handleCloseEdit={handleCloseEdit}
      />
    </div>
  )
}
